import React, { Component } from 'react';
import { Link } from 'gatsby';
import { withFirebase } from '../../../utils/Firebase';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';
import Loading from '../../atoms/Loading';
import Image from '../../atoms/Image';

import PostItem from './PostItem';

import Select from 'react-select';

const options = [
  { value: 'shop_now', label: 'Shop Now' },
  { value: 'no_button', label: 'No Button' },
  { value: 'learn_more', label: 'Learn More' },
  { value: 'download', label: 'Download' },
  { value: 'sign_up', label: 'Sign Up' },
  { value: 'send_message', label: 'Send Message' },
  { value: 'watch_more', label: 'Watch More' },
  { value: 'play_game', label: 'Play Game' },
  { value: 'apply_now', label: 'Apply Now' },
  { value: 'book_now', label: 'Book Now' },
  { value: 'contact_us', label: 'Contact Us' },
  { value: 'see_menu', label: 'See Menu' },
  { value: 'listen_now', label: 'Listen Now' },
  { value: 'get_offer', label: 'Get Offer' },
];

class Home extends Component {
  _initFirebase = false;

  state = {
    posts: [],
    loading: true
  };

  firebaseInit = () => {
    if (this.props.firebase && !this._initFirebase) {
      this._initFirebase = true;

      this.getPosts();
    }
  };

  componentDidMount() {
    this.firebaseInit();
  }

  componentDidUpdate() {
    this.firebaseInit();
  }

  getPosts = () => {
    const { firebase } = this.props;

    firebase
      .posts()
      .get()
      .then(querySnapshot => {
        const data = querySnapshot.docs.map(item => item.data());
        this.setState({
          posts: data,
          loading: false,
        });
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { proof_point, headline, image_url, description, caption, link, display_link, cta_btn, posts } = this.state;
    const { firebase } = this.props;
    let cta = 'Shop Now'

    let slug =
      (headline.match(/^[a-zA-Z0-9 ]*$/, '') &&
      headline.match(/^[a-zA-Z0-9 ]*$/, '')[0]) ||
      '';

    const latestPost = {
      proof_point,
      headline,
      image_url,
      description,
      caption,
      link,
      display_link,
      cta,
      slug:
        slug
          .toLowerCase()
          .split(' ')
          .join('-') +
        Math.floor(Math.random() * 200) +
        1,
    };

    const newPosts = [latestPost, ...posts];

    this.setState({
      posts: newPosts,
      description: '',
      proof_point: '',
      headline: '', 
      image_url: '',
      caption: '', 
      link: '', 
      display_link: '', 
      cta: ''
    });


    firebase.posts().add({
      ...latestPost,
    });
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { posts, proof_point, headline, image_url, description, caption, link, display_link, cta_btn, loading } = this.state;

    if (loading) return <Loading />;

    return (
      <div className="home container">
        <div className="home__details">
        </div>

        <div className="home__posts">
          <div className="home__posts__form card">
            <div className="home__posts__form__title">Create Post</div>
            <form onSubmit={this.handleSubmit}>
              <Input
                name="proof_point"
                type="text"
                value={proof_point}
                labelName="Proof Point"
                onChange={this.handleChange}
                required
              />
              {/* <Input
                name="message"
                type="text"
                value={message}
                labelName="Message (90 character limit)"
                onChange={this.handleChange}
                required
              /> */}
              <Input
                name="headline"
                type="text"
                value={headline}
                labelName="Headline"
                onChange={this.handleChange}
                required
              />
              <Input
                name="image_url"
                type="text"
                value={image_url}
                labelName="Image Url"
                onChange={this.handleChange}
                required
              />
              <Input
                name="description"
                type="text"
                value={description}
                labelName="Description"
                onChange={this.handleChange}
                required
              /> 
              <Input
                name="caption"
                type="text"
                value={caption}
                labelName="Caption"
                onChange={this.handleChange}
                required
              />
              <Input
                name="link"
                type="text"
                value={link}
                labelName="Link "
                onChange={this.handleChange}
                required
              />
              <Input
                name="display_link"
                type="text"
                value={display_link}
                labelName="Display Link"
                onChange={this.handleChange}
                required
              />
            <label>CTA</label>
            <Select
                value={cta_btn}
                name={"cta_btn"}
                // onChange={this.handleChange}
                options={options}
              />

              <Button
                className="home__posts__form__btn"
                type="submit"
              />
            </form>
          </div>


          <div className="home__posts__items">
            {posts &&
              posts.length > 0 &&
              posts.map((item, id) => (
                <div key={id} className="home__post">
                  <PostItem item={item} id={id} />
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withFirebase(Home);
